<template>
    <el-space>
        <ComSearchButton @click="show = !show"></ComSearchButton>
        <ComNimikeCascader 
            v-if="show" 
            v-model="model">
        </ComNimikeCascader>
    </el-space>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ComSearchButton from './buttons/ComSearchButton.vue';
import ComNimikeCascader from './ComNimikeCascader.vue';

const model = defineModel<[number, number, number]>()
const show = ref(false)
</script>